// extracted by mini-css-extract-plugin
export default {"root":"CWhr0","left":"_1sPVX","right":"RoYgO","author":"_1y0JI","actions":"_2RkUi"};